module.exports = __webpack_public_path__ + "img/weiziling.23b08336.jpg";